<template>
    <div class="background">
        <v-container fluid>
            <v-row style="height: 100vh" align="center" justify="center">
                <v-dialog v-model="modalActive" fullscreen>
                    <PreMessageCard />
                </v-dialog>
                <v-card
                    :width="widthCard"
                    :height="heightCard"
                    rounded
                    style="
                        border-radius: 1vw !important;
                        background: linear-gradient(146.1deg, #6d5bb0 0%, #b5a1eb 100%);
                        border: 20px solid #5d5286;
                    "
                >
                    <v-container fluid style="height: 100%">
                        <v-row style="height: 100%" justify="center" v-if="loaded">
                            <v-col cols="8">
                                <v-row style="height: 15%">
                                    <v-col>
                                        <v-row style="height: 100%" justify="end" align="start">
                                            <v-img
                                                src="/img/user/beecoin-3.svg"
                                                :max-height="beecoinTop1Size.maxSize"
                                                :height="beecoinTop1Size.size"
                                                :max-width="beecoinTop1Size.maxSize"
                                                :width="beecoinTop1Size.size"
                                                class="beecoin-top-1"
                                            />
                                        </v-row>
                                    </v-col>
                                    <v-col>
                                        <v-row style="height: 100%" justify="start" align="start">
                                            <v-img
                                                src="/img/user/beecoin-3.svg"
                                                :max-height="beecoinTop2Size.maxSize"
                                                :height="beecoinTop2Size.size"
                                                :max-width="beecoinTop2Size.maxSize"
                                                :width="beecoinTop2Size.size"
                                                class="beecoin-top-2"
                                            />
                                        </v-row>
                                    </v-col>
                                </v-row>
                                <v-row  align="center" justify="center">
                                    <p class="form-title">{{ title }}</p>
                                </v-row>
                                <v-row align="center" justify="center">
                                    <p class="form-text">{{ text }}</p>
                                </v-row>
                                <v-row  align="center" justify="center">
                                    <v-btn
                                        rounded
                                        large
                                        color="#FF6F3A"
                                        dark
                                        :height="buttonSize.height"
                                        :width="buttonSize.width"
                                        class="button-text"
                                        @click="modalActive = true"
                                    >
                                        {{ $t('challenge.initial_text_button') }}
                                    </v-btn>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row style="height: 100%" justify="center" v-else>
                            <v-col cols="8">
                                <v-row>
                                    <v-col>
                                        <v-row justify="center" align="start" class="mt-n5">
                                            <v-skeleton-loader
                                                type="image"
                                                width="100"
                                                height="100"
                                                class="rounded-circle mt-n15"
                                            />
                                        </v-row>
                                    </v-col>
                                </v-row>
                                <v-row align="center" justify="center" class="mt-10">
                                    <v-skeleton-loader
                                        type="text, text"
                                        width="500"
                                        height="50"
                                    />
                                    <v-skeleton-loader
                                        type="text"
                                        width="250"
                                        height="50"
                                    />
                                </v-row>
                                <v-row align="center" justify="center">
                                    <v-skeleton-loader
                                        type="image"
                                        width="300"
                                        height="40"
                                        class="rounded-pill"
                                    />
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card>
            </v-row>
        </v-container>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import PreMessageCard from './PreMessageCard.vue'
import challengeService from '../../services/challenge'
import initialReaderValidation from "../../mixins/InitialReaderValidation";

export default {
    data() {
        return {
            modalActive: false,
        }
    },
    props: ['title', 'text', 'points', 'beecoins', 'loaded'],
    components: {
        PreMessageCard,
    },
    computed: {
        ...mapState({
            user_loaded: (state) => state.userData.user_loaded,
            user_id: (state) => state.userData.user.id,
            course: (state) => state.userData.user.course,
        }),
        widthCard() {
            return this.$vuetify.breakpoint.xs ||
                this.$vuetify.breakpoint.sm ||
                this.$vuetify.breakpoint.md
                ? '80vw'
                : '50vw'
        },
        heightCard() {
            return this.$vuetify.breakpoint.xs ||
                this.$vuetify.breakpoint.sm ||
                this.$vuetify.breakpoint.md
                ? '65vh'
                : '55vh'
        },
        beecoinTop1Size() {
            return {
                size:
                    this.$vuetify.breakpoint.xs ||
                    this.$vuetify.breakpoint.sm ||
                    this.$vuetify.breakpoint.md
                        ? '170px'
                        : '10vw',
                maxSize:
                    this.$vuetify.breakpoint.xs ||
                    this.$vuetify.breakpoint.sm ||
                    this.$vuetify.breakpoint.md
                        ? '170px'
                        : '10vw',
            }
        },
        beecoinTop2Size() {
            return {
                size:
                    this.$vuetify.breakpoint.xs ||
                    this.$vuetify.breakpoint.sm ||
                    this.$vuetify.breakpoint.md
                        ? '90px'
                        : '6vw',
                maxSize:
                    this.$vuetify.breakpoint.xs ||
                    this.$vuetify.breakpoint.sm ||
                    this.$vuetify.breakpoint.md
                        ? '90px'
                        : '6vw',
            }
        },
        beecoinsContentSize() {
            return {
                size:
                    this.$vuetify.breakpoint.xs ||
                    this.$vuetify.breakpoint.sm ||
                    this.$vuetify.breakpoint.md
                        ? '200px'
                        : '9vw',
                maxSize:
                    this.$vuetify.breakpoint.xs ||
                    this.$vuetify.breakpoint.sm ||
                    this.$vuetify.breakpoint.md
                        ? '200px'
                        : '9vw',
            }
        },
        buttonSize() {
            return {
                width:
                    this.$vuetify.breakpoint.xs ||
                    this.$vuetify.breakpoint.sm ||
                    this.$vuetify.breakpoint.md
                        ? '350px'
                        : '18vw',
                height:
                    this.$vuetify.breakpoint.xs ||
                    this.$vuetify.breakpoint.sm ||
                    this.$vuetify.breakpoint.md
                        ? '70px'
                        : '3vw',
            }
        },
    },
    methods: {
        initChallengeByUserId(id) {
            return new Promise((resolve) => {
                challengeService
                    .initTest(id, false, this.isInitialReader)
                    .then((response) => {
                        resolve({
                            ok: true,
                            data: response,
                        })
                    })
                    .catch((err) => {
                        console.error('error: ', err)
                        resolve({
                            ok: false,
                            error: err,
                        })
                    })
            })
        },
    },
    mixins: [initialReaderValidation],
}
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Open+Sans&family=Patua+One&display=swap');

.background {
    background-image: url('/img/wallpaper/maze.png');
    background-size: cover;
    width: auto;
    height: auto;
}

.form-content {
    width: 60%;
    height: 40vw;
    position: relative;
}

.form-item-content {
    position: absolute;
    width: 27vw;
    height: 25vw;
    left: 11.5vw;
    top: 7vw;
}

.bright-points {
    align-items: center;
    padding-left: 5%;
    color: #816ad6;
    margin-top: -4vh;
    margin-bottom: -4vh;
}

.bright-beecoin {
    align-items: center;
    color: darkgoldenrod;
    margin-top: -4vh;
    margin-bottom: -4vh;
}

.form-title {
    color: white;
    font-size: 2.5vw;
}

.form-text {
    font-size: 1.2vw;
    color: white;
}

.beecoin-top-1 {
    z-index: 1;
    position: relative;
    bottom: 11vh;
    left: 5vw;
}

.beecoin-top-2 {
    transform: rotate(15deg);
    position: relative;
    bottom: 13vh;
    left: 1vw;
}

.text-beecoin {
    font-size: 1vw;
}

.button-text {
    text-transform: none;
    font-size: 1vw;
}

@media (max-width: 1264px) {
    .beecoin-top-1 {
        z-index: 1;
        position: relative;
        bottom: 90px;
        left: 80px;
    }

    .beecoin-top-2 {
        transform: rotate(15deg);
        position: relative;
        bottom: 105px;
        left: 20px;
    }

    .form-title {
        color: white;
        font-size: 60px;
    }

    .form-text {
        font-size: 33px;
        color: white;
        min-width: 240px;
    }

    .text-beecoin {
        font-size: 21px;
    }

    .button-text {
        text-transform: none;
        font-size: 20px;
    }
}
</style>
